/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner } from './InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner';
import {
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON,
} from './InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner';

/**
 * 
 * @export
 * @interface InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
 */
export interface InstanceBulkDecisionRequestBidirectionalActionDetailsDetails {
    /**
     * 
     * @type {Array<InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    selections: Array<InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>;
    /**
     * 
     * @type {Array<InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    internal_selections?: Array<InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    time?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    internal_message?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    phone_number_extension?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
     */
    checkbox?: boolean;
}

/**
 * Check if a given object implements the InstanceBulkDecisionRequestBidirectionalActionDetailsDetails interface.
 */
export function instanceOfInstanceBulkDecisionRequestBidirectionalActionDetailsDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "selections" in value;

    return isInstance;
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetailsDetails {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkDecisionRequestBidirectionalActionDetailsDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selections': ((json['selections'] as Array<any>).map(InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON)),
        'internal_selections': !exists(json, 'internal_selections') ? undefined : ((json['internal_selections'] as Array<any>).map(InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON)),
        'date': !exists(json, 'date') ? undefined : json['date'],
        'time': !exists(json, 'time') ? undefined : json['time'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'internal_message': !exists(json, 'internal_message') ? undefined : json['internal_message'],
        'phone_number': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'phone_number_extension': !exists(json, 'phone_number_extension') ? undefined : json['phone_number_extension'],
        'checkbox': !exists(json, 'checkbox') ? undefined : json['checkbox'],
    };
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSON(value?: InstanceBulkDecisionRequestBidirectionalActionDetailsDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selections': ((value.selections as Array<any>).map(InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON)),
        'internal_selections': value.internal_selections === undefined ? undefined : ((value.internal_selections as Array<any>).map(InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON)),
        'date': value.date,
        'time': value.time,
        'message': value.message,
        'internal_message': value.internal_message,
        'phone_number': value.phone_number,
        'phone_number_extension': value.phone_number_extension,
        'checkbox': value.checkbox,
    };
}

